import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cancelTask } from '../api';

export function useCancelTask(jobId: string, taskId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reason?: string) => cancelTask(jobId, taskId, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
      queryClient.invalidateQueries({ queryKey: ['job', jobId] });
      queryClient.invalidateQueries({ queryKey: ['task', jobId, taskId] });
    },
  });
}
